<template>
    <div data-cy="container_mission_detail_condition_page">
        <div class="max-w-500 mx-auto">
            <TopBarBackImage data-cy="btn_mission_detail_condition_back" @onClickBack="clickBack()" />
                <DetailAndCondition data-cy="component_mission_detail_condition" />
            <!-- </div> -->

        </div>
    </div>
</template>
<script>
//helper
// import Util from '@/helper/Utility.js';
import CacheHelper from '@/helper/CacheHelper';
//component
import TopBarBackImage from '@/components/Layout/TopBar/TopBarBackImage.vue';
import DetailAndCondition from '../component/DetailAndCondition.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service

export default {
    name: "DetailAndConditionGame",
    mixins: [ModalMixin, AuthPageMixin, AuthStatusMixin, LocaleMixin],
    components: {
        TopBarBackImage,
        DetailAndCondition,
    },
    data: function () {
        return {
            textDetail: null,
            type: '',
            index: null,
        };
    },
    created: function(){
        this.tracking.screenName('mission');
        this.tracking.event('mission_game', 'mission_game', null, null);
    },
    methods: {
        clickBack: function() {
            let cache = new CacheHelper('session');
            cache.removeCache('target_point');

            this.tracking.event('mission_game', 'mission_game_back', null, null);
            this.$router.back();
        },
    }
}
</script>
// <style lang="scss" scoped>
// @import "@/style/base/base.scss";

// .bg-mission-detail-cond {
//     height: calc(100vh - 23px);
//     background-image: url('../../../assets/bg/bg-mission-detailcond.jpg');
//     background-repeat: no-repeat;
//     background-size: cover;
//     background-position: bottom center;
//     margin-top: -52px;

//     @media(max-height: 680px){
//         height: 100%;
//         background-attachment: fixed;
//     }
// }
// </style>
